import { render } from "./UnsereMotivation.vue?vue&type=template&id=e89af35c"
import script from "./UnsereMotivation.vue?vue&type=script&lang=js"
export * from "./UnsereMotivation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__